import React, { useState } from "react";
import CheckBoxFilled from "./CheckBoxFilled.svg";
import CheckBoxOutlineBlankOutlined from "./CheckBoxOutlineBlankOutlined.svg";
import P from "./p";

export default function Checkbox({ name, label, form, setForm = () => { }, style }) {
  const [checked, setChecked] = useState(form[name]);
  function handleClick() {
    setChecked(!checked);
    setForm({ ...form, [name]: !checked });
  }
  const error = form.errors !== null ? form.errors[name]?.reduce((n, m) => m, []) : null;
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", alignContent: "center", ...style }}>
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={handleClick}
          onKeyPress={(e) => (e.key === "Enter" ? handleClick() : null)}
          tabIndex="0"
        >
          <div style={{ fontSize: "24px", lineHeight: "20px", marginRight: "1rem" }}>
            {checked ? <CheckBoxFilled /> : <CheckBoxOutlineBlankOutlined />}
          </div>
          <div style={{ lineHeight: "14px", letterSpacing: ".25px" }}>{label}</div>
        </div>
      </div>
      <P style={{ color: "red" }}>{error}</P>
    </>
  );
}
